module.exports = __webpack_public_path__ + "img/add_theme_desktop_2.6618b5c8.png";